import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';
import ContactForm from '../components/contact-form';

<template>
  {{pageTitle (t "contact.title") separator=" | "}}

  {{! Page Header }}
  <section class="page-header" aria-labelledby="contact-title">
    <div class="container">
      <div class="section-header">
        <h1 id="contact-title" class="section-header__title">{{t
            "contact.title"
          }}</h1>
        <p class="section-header__description">
          {{t "contact.subtitle"}}
        </p>
      </div>
    </div>
  </section>

  {{! Contact Content }}
  <section class="section" aria-labelledby="contact-form-title">
    <div class="container">
      <div class="contact-grid">
        {{! Contact Form }}
        <div>
          <h2 id="contact-form-title">{{t "contact.form.title"}}</h2>
          <p class="mb-4">
            {{t "contact.form.intro"}}
          </p>

          <ContactForm />
        </div>

        {{! Contact Information }}
        <div>
          <h2>{{t "contact.other_ways.title"}}</h2>

          <div class="contact-info__label mb-4">{{t
              "contact.other_ways.connect"
            }}</div>
          <div class="social-links social-links--light">
            <a
              href="https://www.linkedin.com/in/borisdevloed/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn (opens in new window)"
              title="LinkedIn"
              class="social-link"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
                />
              </svg>
            </a>
            <a
              href="https://github.com/bdevloed"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub (opens in new window)"
              title="GitHub"
              class="social-link"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z"
                />
              </svg>
            </a>
          </div>

          {{! Company Information with RDFa }}
          <div
            class="card card--bordered mt-8"
            vocab="https://schema.org/"
            typeof="Organization"
          >
            <h3 class="card__title">{{t "contact.company_info.title"}}</h3>
            <address class="address-normal">
              <p>
                <strong property="name">DEVLOED.COM</strong><br />
                <span property="additionalType">{{t
                    "contact.company_info.legal_form"
                  }}</span>
              </p>
              <p property="address" typeof="PostalAddress">
                <span property="streetAddress">Floridalaan 77 bus 10</span><br
                />
                <span property="postalCode">1180</span>
                <span property="addressLocality">Ukkel</span><br />
                <span property="addressCountry">Belgium</span>
              </p>
              <p>
                <strong>{{t "contact.company_info.kbo_number"}}</strong>
                <span property="taxID">0759.557.312</span><br />
                <strong>{{t "footer.rpr"}}</strong>
                {{t "footer.rpr_court"}}<br />
                <strong>{{t "contact.company_info.vat"}}</strong>
                BE 0759.557.312
              </p>
              <p class="mb-0">
                <a
                  href="https://kbopub.economie.fgov.be/kbopub/toonondernemingps.html?ondernemingsnummer=759557312"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="View company details on KBO Public Search (opens in new window)"
                >
                  {{t "contact.company_info.view_kbo"}}
                </a>
              </p>
            </address>
            <meta property="url" content="https://devloed.com" />
            <link
              property="sameAs"
              href="https://www.linkedin.com/in/borisdevloed/"
            />
            <link property="sameAs" href="https://github.com/bdevloed" />
          </div>
        </div>
      </div>
    </div>
  </section>

  {{! Activities Section }}
  <section class="section section--alt" aria-labelledby="activities-title">
    <div class="container">
      <h2 id="activities-title">{{t "contact.activities.title"}}</h2>
      <p class="mb-4">
        {{t "contact.activities.intro"}}
      </p>
      <div class="services-grid">
        <div class="card card--bordered">
          <h3 class="card__title">62.100</h3>
          <p class="card__description">{{t "contact.activities.code_62100"}}</p>
        </div>
        <div class="card card--bordered">
          <h3 class="card__title">70.200</h3>
          <p class="card__description">{{t "contact.activities.code_70200"}}</p>
        </div>
        <div class="card card--bordered">
          <h3 class="card__title">62.900</h3>
          <p class="card__description">{{t "contact.activities.code_62900"}}</p>
        </div>
        <div class="card card--bordered">
          <h3 class="card__title">62.200</h3>
          <p class="card__description">{{t "contact.activities.code_62200"}}</p>
        </div>
        <div class="card card--bordered">
          <h3 class="card__title">63.920</h3>
          <p class="card__description">{{t "contact.activities.code_63920"}}</p>
        </div>
      </div>
    </div>
  </section>
</template>
